export default class ObjectHelper {
  static get(obj, key, def = undefined) {
    const _key = (Array.isArray(key) && key) || key.split(".");
    let res = obj;
    for (let i = 0; i < _key.length; i++) {
      if (res === undefined || res === null) {
        break;
      }
      res = res[_key[i]];
    }
    return (res === undefined && def) || res;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ObjectHelper.js